import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Yeah but you're weird",
  "description": "",
  "published": "2009-10-06T00:00:00.000Z",
  "redirect_from": ["/blog/yeah-but-youre-weird/swizec/752"],
  "categories": "food for thought, intrigues, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.daylife.com/image/0ebe0Vyf3p3oA?utm_source=zemanta&utm_medium=p&utm_content=0ebe0Vyf3p3oA&utm_campaign=z1"
          }}><img parentName="a" {...{
              "src": "https://cache.daylife.com/imageserve/0ebe0Vyf3p3oA/150x119.jpg",
              "alt": "LOS ANGELES, CA - FEBRUARY 22: (EDITORS NOTE:...",
              "title": "LOS ANGELES, CA - FEBRUARY 22:  (EDITORS NOTE:..."
            }}></img></a></p>
        <p parentName="li">{`Image by `}<a parentName="p" {...{
            "href": "http://www.daylife.com/source/Getty_Images"
          }}>{`Getty Images`}</a>{` via `}<a parentName="p" {...{
            "href": "http://www.daylife.com"
          }}>{`Daylife`}</a></p>
      </li>
    </ul>
    <p>{`Most of my life I've been listening to people telling me I'm weird. This, of course, isn't too big a problem since I actually enjoy being weird, in fact I absofuckinglutely LOVE being weird. Why would I want to be normal and boring? Snoozeville!`}</p>
    <p>{`However there are those certain occasions where being weird is just fucking stupid. And it's not because I had a problem being weird, it's when people use it as an excuse to be stupid idiots.`}</p>
    <p>{`Picture this scenario: You're deep in a debate with somebody, you keep presenting at least marginally intelligent arguments, you look stuff up online, you get good references for your claims, when you do pull something out of your arse you make sure it makes sense at least on the front of it. Basically you spend several tens of minutes on every rebuttal you write.`}</p>
    <p>{`But the other person ... after presenting a strawman or two, after making an obviously idiotic argument or three simply dismisses the whole discussion with `}<em parentName="p">{`Yeah, but you're weird.`}</em></p>
    <p>{`Gee thanks mister person,`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      